export default __webpack_public_path__ + "2e128487c4fe916027f6df6c43aaa120.svg";